import Label from './Label';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import './styles.scss';
import ValidationError from './ValidationError';

const TextArea = ({
  type,
  label,
  labelHidden,
  name,
  onChange,
  required,
  register,
  error,
  ...rest
}) => {
  const getClassNames = () =>
    classNames('form__item', `form__item--${type}`, `form__item--${name}`);

  const handleChange = event => {
    onChange && onChange(event.target.name, event.target.value);
  };

  return (
    <div className={getClassNames()}>
      <Label
        label={label}
        name={name}
        labelHidden={labelHidden}
        required={required}
      />
      <textarea
        type={type}
        name={name}
        id={name}
        rows='5'
        className={classNames('form__textarea', error && 'form__textarea--error')}
        onChange={handleChange}
        aria-required={required}
        aria-invalid={error ? 'true' : 'false'}
        {...register(name)}
        {...rest}
      />
      {/* {console.log('error:', error)} */}
      {error && <ValidationError>{error}</ValidationError>}
    </div>
  );
};

TextArea.defaultProps = {
  labelHidden: false,
  onChange: null,
  required: false,
};

TextArea.propTypes = {
  type: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  labelHidden: PropTypes.bool,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  error: PropTypes.node,
};

export default TextArea;